import * as tslib_1 from "tslib";
import { OnInit, ViewContainerRef } from '@angular/core';
import { ESRI } from '../../../../esri-loader-util';
import { FillStyleOptions, LineStyleOptionsForArcServer, LineStyleOptionsWithNull } from '../../../../selectionOptions';
import { LayerService } from '../../../../services/layer.service';
import { PrintService } from '../../../../services/print.service';
import { BaseSymbolEditorComponent } from '../baseSymbolEditor';
var Color;
var PolygonSymbolEditorComponent = /** @class */ (function (_super) {
    tslib_1.__extends(PolygonSymbolEditorComponent, _super);
    function PolygonSymbolEditorComponent(_vcr, printService, layerService) {
        var _this = _super.call(this, _vcr, layerService) || this;
        _this.printService = printService;
        _this.layerService = layerService;
        _this.lineStyleOptions = LineStyleOptionsWithNull;
        _this.fillStyleOptions = FillStyleOptions;
        _this.showBackgroundColorPicker = false;
        _this.showOutlineColorPicker = false;
        _this.applyChange = function () {
            _this.polygonSymbol.color = Color.fromRgb(_this.symbolColor);
            _this.polygonSymbol.style = _this.fillStyle;
            if (_this.polygonSymbol.outline) {
                _this.polygonSymbol.outline.width = _this.outlineWidth;
                _this.polygonSymbol.outline.style = _this.outlineStyle;
                _this.polygonSymbol.outline.color = Color.fromRgb(_this.outlineColor);
            }
            window.dispatchEvent(new CustomEvent('symbolChange', { detail: _this.uniqueLayerId }));
        };
        return _this;
    }
    Object.defineProperty(PolygonSymbolEditorComponent.prototype, "isLineStyleSupportedForPrinting", {
        get: function () {
            return this.printService.validateServerSideLayerStyle(this.outlineStyle);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PolygonSymbolEditorComponent.prototype, "replacementLineStyle", {
        get: function () {
            return this.printService.getSupportedLineStyle(this.outlineStyle);
        },
        enumerable: true,
        configurable: true
    });
    PolygonSymbolEditorComponent.prototype.ngOnInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, ESRI.Color];
                    case 1:
                        Color = _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(PolygonSymbolEditorComponent.prototype, "layerType", {
        set: function (val) {
            if (val === 'map-image' || val === 'dynamic') {
                this.lineStyleOptions = LineStyleOptionsForArcServer;
            }
            else {
                this.lineStyleOptions = LineStyleOptionsWithNull;
            }
        },
        enumerable: true,
        configurable: true
    });
    PolygonSymbolEditorComponent.prototype.bindForm = function () {
        if (this.layerSymbol) {
            this.polygonSymbol = this.layerSymbol;
            this.symbolColor = "rgba(" + this.polygonSymbol.color.toRgba() + ")";
            this.originalColor = this.symbolColor;
            this.fillStyle = this.polygonSymbol.style;
            if (this.polygonSymbol.outline) {
                this.outlineColor = "rgba(" + this.polygonSymbol.outline.color.toRgba() + ")";
                this.originalOutlineColor = this.outlineColor;
                this.outlineStyle = this.polygonSymbol.outline.style;
                this.outlineWidth = this.polygonSymbol.outline.width;
            }
        }
    };
    return PolygonSymbolEditorComponent;
}(BaseSymbolEditorComponent));
export { PolygonSymbolEditorComponent };
